import React from 'react';
import type { Node } from 'reactflow';
import type { NodeChange } from 'reactflow';

export interface SparkBoardContextValue {
  nodes: Node[];
  setNodes: React.Dispatch<React.SetStateAction<Node[]>>;
  onNodesChange: (changes: NodeChange[]) => void;
}

// Create a context with initial value as undefined
export const SparkBoardContext = React.createContext<
  SparkBoardContextValue | undefined
>(undefined);
